import SquareRoundedIcon from '@mui/icons-material/SquareRounded';
import {
  Checkbox,
  CheckboxProps,
  FormControlLabel,
  Stack,
  styled,
  Typography,
} from '@mui/material';
import { useTranslation } from '../../../../../services/translation/hooks/useTranslation';
const StyledCheckbox = styled(Checkbox)<CheckboxProps>(() => ({
  '&.Mui-checked': {
    color: 'var(--checked-color)',
  },
}));

export const BlueberrySizeChartLegend = () => {
  const { t } = useTranslation();
  return (
    <Stack direction={'row'} sx={{ pointerEvents: 'none' }}>
      <FormControlLabel
        control={
          <StyledCheckbox
            checkedIcon={<SquareRoundedIcon fontSize='inherit' />}
            checked
            size={'small'}
            sx={{
              '--checked-color': (theme) =>
                theme.colors.canopy.components.barChart.green,
            }}
          />
        }
        label={
          <Typography fontSize={'0.8rem'} fontWeight={600} lineHeight={'166%'}>
            {t('Green')}
          </Typography>
        }
      />
      <FormControlLabel
        control={
          <StyledCheckbox
            checkedIcon={<SquareRoundedIcon fontSize='inherit' />}
            checked
            size={'small'}
            sx={{
              '--checked-color': (theme) =>
                theme.colors.canopy.components.barChart.pink,
            }}
          />
        }
        label={
          <Typography fontSize={'0.8rem'} fontWeight={600} lineHeight={'166%'}>
            {t('Pink')}
          </Typography>
        }
      />
      <FormControlLabel
        control={
          <StyledCheckbox
            checkedIcon={<SquareRoundedIcon fontSize='inherit' />}
            checked
            size={'small'}
            sx={{
              '--checked-color': (theme) =>
                theme.colors.canopy.components.barChart.purple,
            }}
          />
        }
        label={
          <Typography fontSize={'0.8rem'} fontWeight={600} lineHeight={'166%'}>
            {t('Purple')}
          </Typography>
        }
      />
      <FormControlLabel
        control={
          <StyledCheckbox
            checkedIcon={<SquareRoundedIcon fontSize='inherit' />}
            checked
            size={'small'}
            sx={{
              '--checked-color': (theme) =>
                theme.colors.canopy.components.barChart.blue,
            }}
          />
        }
        label={
          <Typography fontSize={'0.8rem'} fontWeight={600} lineHeight={'166%'}>
            {t('Blue')}
          </Typography>
        }
      />
    </Stack>
  );
};
